module.exports = __webpack_public_path__ + "static/media/share.d8903e7b.png";